// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"9":"fb1a9cb710ec7a1a","447":"f68ea40362f006ba"}[chunkId] + ".js";
};